import VueRouter from 'vue-router';
import { router as singleTplRouter } from './views/single/router';
import { router as unionTplRouter } from './views/union/router';
import { TEMPLATE_MODE } from './constants';
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/login.vue'),
    meta: {
      title: '登录'
    }
  }
];

export async function resolveRouter(userType, code, tpl, mode) {
  if (mode === TEMPLATE_MODE.SINGLE) {
    const tplRoutes = await singleTplRouter(userType, code, tpl);
    routes.push(...tplRoutes);
  }
  if (mode === TEMPLATE_MODE.UNION) {
    const tplRoutes = await unionTplRouter(userType, code, tpl);
    routes.push(...tplRoutes);
  }

  const router = new VueRouter({
    routes
  });

  //全局路由器钩子，跳转之前
  router.beforeEach((to, from, next) => {
    if (to.name === 'login' && from.meta && from.meta.loginCallback) {
      to.params.redirectObject = {
        path: from.path
      };
    }
    if (to.query && to.query.doc_title) {
      // 修改页面标题
      document.title = to.query.doc_title;
    } else if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    }
    next();
  });

  return router;
}
